<template lang="pug">
.content
  grid(
    name='',
    desc=''
    :checkboxes='false'
    :views='false'
    layout='frame'
    search=true
    resizing=false
    :endpoint='api.$.approval.getApprovalRulesHistory'
    ref='ApprovalHistoryGrid'
  )
</template>

<script>

import Grid from '@/components/Grid'
import model from './model'
import { EventBus } from '@/event-bus'
import events from '@/core/events/events'

export default {
  components: {
    Grid
  },

  data() {
    return {
      model
    }
  },

  created() {
    EventBus.$on(events.APPROVAL_RULE.REFRESH, r => {
      this.refresh()
    })
  },

  methods: {
    refresh() {
      this.$refs.ApprovalHistoryGrid.quickSearch()
      this.$refs.ApprovalHistoryGrid.onSelectAll(false)
    }
  }
}

</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/_modules/Approvals/Approval-history/index.vue